import React from 'react';
import SmartModal from '../../smart/modal';
import FieldGroup from '../../smart/field_group';

export default class Modal extends SmartModal {
  renderForm() {
    return (
      <div>
        <FieldGroup
          type="text"
          label="Title"
          name="region[title]"
          defaultValue={this.formValue('title')}
          error={this.formError('title')}
        />
      </div>
    );
  }
}
